import React, { useEffect, useState } from 'react';
import { Box } from '@components/Box';
import { FaqList } from '@components/FaqList';
import { TextPairing } from '@components/TextPairing';
import { Layout, Seo } from '@layout';
import { AbcSection } from '@sections/shared/AbcSection';
import { ColoredBlockSection } from '@sections/shared/ColoredBlockSection';
import { faqData } from '@data-ts/pages/faq';
import { faqQuestionsData } from '@data-ts/components/FaqQuestions';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';

const StyledSubHeadTextPairing = styled(TextPairing)`
  .faq-link {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const Faq = () => {
  const isMobile = useThemeMediaQuery('below_sm');
  const [isMobileScreen, setIsMobileScreen] = useState(true);
  useEffect(() => {
    setIsMobileScreen(Boolean(isMobile));
  }, [isMobile]);
  return (
    <Layout isTransparentHeader={isMobileScreen} transparentJoyLogoColor="purple6">
      <Seo title={faqData.seoText} canonicalURL={'https://withjoy.com/faq/'} />
      <Box backgroundColor="yellow1" paddingTop={[11, 10]} paddingBottom={10} paddingX={[5, 5, 11]}>
        <div style={{ maxWidth: '856px', margin: 'auto' }}>
          <StyledSubHeadTextPairing
            alignment="center"
            title={faqData.title}
            titleVariant="hed72Hero"
            titleColor="purple6"
            titleTagName="h1"
            body={ReactHtmlParser(faqData.content)}
            bodyColor="purple6"
            bodyVariant="dek24"
          />
        </div>
      </Box>
      <span itemScope itemType="https://schema.org/FAQPage">
        <ColoredBlockSection backgroundColor="yellow1" sideHeaderText={faqData.generalHeader}>
          <FaqList questionNodes={faqQuestionsData.general} color="purple6" isLinkHidden />
        </ColoredBlockSection>
        <ColoredBlockSection backgroundColor="blue2" sideHeaderText={faqData.websiteHeader}>
          <FaqList color="blue6" questionNodes={faqQuestionsData.weddingWebsite} isLinkHidden />
        </ColoredBlockSection>
        <ColoredBlockSection backgroundColor="yellow1" sideHeaderText={faqData.rsvpHeader}>
          <FaqList questionNodes={faqQuestionsData.guestList} color="purple6" isLinkHidden />
        </ColoredBlockSection>
        <ColoredBlockSection backgroundColor="blue2" sideHeaderText={faqData.appHeader}>
          <FaqList questionNodes={faqQuestionsData.guestApp} color="blue6" isLinkHidden />
        </ColoredBlockSection>
      </span>
      <AbcSection />
    </Layout>
  );
};

export default Faq;
